const transformBase64 = async (inputFile) => {
  return new Promise((resolve, reject) => {
    var fileReader = new FileReader();

    // If error occurs, reject the promise
    fileReader.onerror = () => {
      reject("Err");
    };

    // Define an onload handler that's called when file loaded
    fileReader.onload = () => {
      // File data loaded, so proceed to call setState
      if (fileReader.result !== undefined) {
        const pure = fileReader.result.substring(fileReader.result.indexOf(",") + 1);

        resolve(pure);
      } else {
        reject("Err");
      }
    };

    fileReader.readAsDataURL(inputFile);
  });
};

export const FILE_UTILS = { transformBase64 };
